var CrmSoftwareList = {
  Must: "Must G5",
  Lomaco: "Lomaco",
};

module.exports = CrmSoftwareList;
